import camelcase from "camelcase";

const toCamelCase = array => array.map(item => camelcase(item));

// Recrusively transform required attributes to camelCase
export const transformRequiredFields = data => {
  let newObject = {
    ...data,
  };

  if (data.required) {
    newObject = { ...newObject, required: toCamelCase(newObject.required) };
  }

  if (data.properties) {
    const keys = Object.keys(data.properties);
    const properties = keys.reduce((obj, key) => {
      if (data.properties[key] && typeof data.properties[key] === "object") {
        return {
          ...obj,
          [key]: transformRequiredFields(data.properties[key]),
        };
      }

      return { ...obj, [key]: data.properties[key] };
    }, {});

    newObject = {
      ...newObject,
      properties,
    };
  }

  return newObject;
};

export const transformError = e => {
  if (typeof e === "string") {
    return e;
  } else return e.data && e.data.messages ? e.data.messages.join(" ") : JSON.stringify(e.data);
};

export const strToTitleCase = (str: string): string => {
  return str
    .toLowerCase()
    .split(" ")
    .map(function(word) {
      return word.replace(word[0], word[0].toUpperCase());
    })
    .join(" ");
};

const capitalizeWords = array => {
  return array.map(string => string[0].toUpperCase() + string.slice(1).toLowerCase());
};

export const toTitleCase = string => {
  const arrayOfStrings = capitalizeWords(string.split(" "));
  return arrayOfStrings.join(" ");
};

export const transformCamelCaseToSentenceCase = string => {
  const result = string.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const isNilorEmpty = data => !data || !data.length;

export const transformBooleanToString = (field, t) => (obj: Object) =>
  t(obj[field] === true ? "YES" : "NO");
